export default __webpack_public_path__ + "static/media/profit.f6c9b889.mp3";